// extracted by mini-css-extract-plugin
module.exports = {"contactLi":"ContactListItem_contactLi__947Jv","contactLiP":"ContactListItem_contactLiP__2YrRr","contactLiBtn":"ContactListItem_contactLiBtn__1FS8S"};